import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '安全指南', path: '/category/anquan' },
    { label: '新手入门', path: '/category/rumen' },
    { label: '官方公告', path: '/category/gonggao' },
    { label: '常见问题', path: '/category/wenti' },
    { label: '关于我们', path: '/about' },
  ],
  services: [
    { label: '官方认证', path: '#' },
    { label: '安全验证', path: '#' },
    { label: '实名保障', path: '#' },
    { label: '帮助中心', path: '/category/wenti' },
    { label: '用户协议', path: '#' },
    { label: '隐私政策', path: '#' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
                <div className="w-9 h-9 flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-primary-500"></i>
                </div>
                <span className="text-lg font-bold text-foreground-950 font-heading">91官网</span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                官方正版入口 · 安全认证平台<br />
                为您提供安全可靠的访问服务
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="mailto:support@91guanwang.com" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" aria-label="邮箱">
                  <i className="ri-mail-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4 font-heading">快速导航</h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.navigation.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4 font-heading">服务支持</h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.services.map((link) => (
                  <li key={link.label}>
                    <a href={link.path} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4 font-heading">联系我们</h4>
              <ul className="flex flex-col gap-2.5">
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-mail-line text-sm text-secondary-500"></i>
                  </div>
                  <span className="text-sm text-foreground-600">support@91guanwang.com</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-phone-line text-sm text-secondary-500"></i>
                  </div>
                  <span className="text-sm text-foreground-600">400-XXX-XXXX</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-time-line text-sm text-secondary-500"></i>
                  </div>
                  <span className="text-sm text-foreground-600">工作日 9:00 - 18:00</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-200/50 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 91官网 版权所有 | 本站为官方认证信息平台
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">用户协议</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}